<template>
  <button :disabled="busy" :type="type" :class="classes" @click="btnClick">
    <span v-if="busy">
      <span
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      >
      </span>
      {{ loadText }}
    </span>
    <span v-else>
      {{ Text }}
    </span>
  </button>
</template>

<script>
export default {
  name: "ButtonLoader",
  props: {
    busy: {
      default: false,
      type: Boolean
    },
    type: {
      default: "submit",
      type: String
    },
    classes: {
      default: "",
      type: String
    },
    loadText: {
      default: "",
      type: String
    },
    Text: {
      default: "",
      type: String
    }
  },
  methods: {
    btnClick() {
      this.$emit('btn-click');
    }
  }
};
</script>

<style scoped></style>
